<div class="container">
  <h1 class="page-title">Pesquisar Processo</h1>

  <mat-card class="filtro-card">
    <form [formGroup]="form" (ngSubmit)="pesquisar()">
      <div class="form-row">
        <mat-form-field appearance="outline">
          <mat-label>Número Benefício</mat-label>
          <input matInput formControlName="numBen" />
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>CPF</mat-label>
          <input matInput formControlName="cpf" />
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Servidor</mat-label>
          <input matInput formControlName="servidor" />
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Status</mat-label>
          <mat-select formControlName="status">
            <mat-option [value]="''">-- Selecione --</mat-option>
            <mat-option *ngFor="let s of statusOpcoes" [value]="s.value">
              {{ s.label }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="form-row">
        <mat-form-field appearance="outline">
          <mat-label>Número Processo</mat-label>
          <input matInput formControlName="numProc" />
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Matrícula</mat-label>
          <input matInput formControlName="matricula" />
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Órgão</mat-label>
          <mat-select formControlName="idOrgao">
            <mat-option [value]="''">-- Selecione --</mat-option>
            <mat-option *ngFor="let o of orgaos" [value]="o.value">
              {{ o.label }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Local Atual</mat-label>
          <mat-select formControlName="idLocalAtual">
            <mat-option [value]="''">-- Selecione --</mat-option>
            <mat-option *ngFor="let l of locaisAtuais" [value]="l.value">
              {{ l.label }}
            </mat-option>
          </mat-select>
        </mat-form-field>


      </div>

      <div class="actions">
        <button mat-raised-button color="primary" type="submit">Pesquisar</button>
        <button mat-raised-button (click)="limpar()" type="button">Limpar</button>
      </div>
    </form>
  </mat-card>

  <mat-card class="resultados-card">
    <div *ngIf="loading" class="loading-container">
      <mat-spinner diameter="40"></mat-spinner>
    </div>

    <table mat-table [dataSource]="processos" class="mat-elevation-z2">
      <ng-container matColumnDef="numProc">
        <th mat-header-cell *matHeaderCellDef>Número Processo</th>
        <td mat-cell *matCellDef="let p">{{ p.numProc || p.numeroProcesso || '-' }}</td>
      </ng-container>

      <ng-container matColumnDef="nome">
        <th mat-header-cell *matHeaderCellDef>Nome</th>
        <td mat-cell *matCellDef="let p">{{ p.nome || p.nomeServidor || '-' }}</td>
      </ng-container>

      <ng-container matColumnDef="matricula">
        <th mat-header-cell *matHeaderCellDef>Matrícula</th>
        <td mat-cell *matCellDef="let p">{{ p.matriculaAbertura || '-' }}</td>
      </ng-container>

      <ng-container matColumnDef="tipo">
        <th mat-header-cell *matHeaderCellDef>Tipo</th>
        <td mat-cell *matCellDef="let p">{{ labelTipo(p.tipo || p.tipoAposentadoria) }}</td>
      </ng-container>

      <ng-container matColumnDef="orgao">
        <th mat-header-cell *matHeaderCellDef>Órgão</th>
        <td mat-cell *matCellDef="let p">{{ p.siglaOrgaoAbertura || '-' }}</td>
      </ng-container>

      <ng-container matColumnDef="localAtual">
        <th mat-header-cell *matHeaderCellDef>Local Atual</th>
        <td mat-cell *matCellDef="let p">{{ p.localAtualNome || '-' }}</td>
      </ng-container>

      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef>Status</th>
        <td mat-cell *matCellDef="let p">{{ p.statusDescricao || labelStatus(p.status) }}</td>
      </ng-container>

      <ng-container matColumnDef="dataAbertura">
        <th mat-header-cell *matHeaderCellDef>Data Abertura</th>
        <td mat-cell *matCellDef="let p">
          {{ (p.dataAbertura | date : 'dd/MM/yyyy') || '-' }}
        </td>
      </ng-container>

      <ng-container matColumnDef="diasLocal">
        <th mat-header-cell *matHeaderCellDef>Dias Local</th>
        <td mat-cell *matCellDef="let p">{{ p.diasLocal ?? '-' }}</td>
      </ng-container>

      <ng-container matColumnDef="acoes">
        <th mat-header-cell *matHeaderCellDef>Ações</th>
        <td mat-cell *matCellDef="let p">
          <button mat-icon-button color="primary" (click)="abrirProcesso(p)">
            <mat-icon>folder_open</mat-icon>
          </button>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>

    <div *ngIf="!loading && processos.length === 0" class="empty-message">
      Nenhum processo encontrado.
    </div>

    <mat-paginator
      [length]="length"
      [pageSize]="10"
      [pageSizeOptions]="[5, 10, 20]"
      (page)="onPageChange($event)"
    ></mat-paginator>
  </mat-card>
</div>
